import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { createInterpolatedTranslationKey, createTranslatedText, TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { filtersPanelTranslationKeys } from '../../../../translations';
import { PatientFilterPanelSearchParam } from '../../PatientFilterPanel.types';

export const createPatientGroupsTriggerLabelExtractor = (
   totalCount: number,
   translate: TranslateFunction
): ((chosenPractitioners: PatientGroup[]) => string) => {
   return (chosenPatientGroups) => {
      if (chosenPatientGroups.length === 1) {
         return chosenPatientGroups.at(0)!.name;
      }
      const translationKey = createInterpolatedTranslationKey(filtersPanelTranslationKeys.patientGroups.chosenOptions, {
         count: chosenPatientGroups.length,
         totalCount: totalCount,
      });
      return translate(translationKey);
   };
};

export const createPatientGroupsCodec = (
   patientGroups: PatientGroup[]
): FilterPanelControllerCodecConfigArray<PatientGroup> => ({
   type: 'array',
   items: patientGroups,
   keyGenerator: (patientGroup) => patientGroup.id,
});

export const patientGroupsDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   PatientGroup[],
   PatientFilterPanelSearchParam.PATIENT_GROUPS
> = (currentPatientGroups) => {
   return currentPatientGroups.map((patientGroup) => ({
      targetValue: currentPatientGroups.filter((currentPatientGroup) => currentPatientGroup.id !== patientGroup.id),
      label: createTranslatedText(patientGroup.name),
      testId: `patientGroup-${patientGroup.id}`,
   }));
};
